"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cache_1 = require("./Cache");
exports.Cache = Cache_1.Cache;
var mutateKeys_1 = require("./layers/mutateKeys");
exports.mutateKeysLayer = mutateKeys_1.mutateKeys;
var mutateValues_1 = require("./layers/mutateValues");
exports.mutateValuesLayer = mutateValues_1.mutateValues;
var prefixLayer_1 = require("./layers/prefixLayer");
exports.prefixLayer = prefixLayer_1.prefixLayer;
var compose_1 = require("./utils/compose");
exports.compose = compose_1.compose;
exports.default = Cache_1.Cache;
//# sourceMappingURL=index.js.map